module.exports = __webpack_public_path__ + "img/menu-bg9.5d2102f0.png";